import { get } from "lodash";
import store from "../store";
import {
  SET_CONTRACT
} from "../store/contract/actionTypes";


// contract  요청 팝업 type이 없는 경우 목록 노출
export const contractRequest = (type, options, mode = 'create') => {
  setContract({
    type,
    isOpen: true,
    mode,
    ...options
  });
};

// contract  요청 팝업 상세
export const contractDetail = async (contract = {}, options) => {

  //console.log('[contract util] contract : ', contract)
  const type = get(contract, 'type');
  const contractIdx = get(contract, 'idx');

  setContract({
    type,
    isOpen: true,
    mode: 'detail',
    contractIdx,
    submit: get(options, 'submit'),
    ...options
  });
};


export const setContract = (options = {
  isOpen: false,
  type: null,
  target: null,
  contractIdx: null,
  mode: null
}) => {
  store.dispatch({
    type: SET_CONTRACT,
    payload: {
      ...options
    }
  });
}

